module.exports = "/templates/bds/public/font/5024e9b25bf8074067819efc65c4bd66.woff";